import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';
import { handleUnsafeOptionalChaining } from '~/tools/lint/handleUnsafeOptionalChaining';

const reset = () => defaultState;

const defaultState = {};

const replaceUnmappedValues = (state, action) => {
  const result = action?.payload;
  if (!result) return;
  state[result.benchmarkAttributeId] = result.unmappedAttributeValues;
};

const updateUnmappedValues = (state, action) => {
  const { benchmarkAttributeId, names } = handleUnsafeOptionalChaining(action?.payload);
  if (!benchmarkAttributeId) return;
  state[benchmarkAttributeId] = state[benchmarkAttributeId].filter((value) => !names.includes(value));
};

const unmappedAttributeValues = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);

  builder.addCase(benchmarkActions.fetchUnmappedAttributeValues.fulfilled, replaceUnmappedValues);

  builder.addCase(benchmarkActions.mapValuesToBenchmarkAttributeValue.fulfilled, updateUnmappedValues);
});

export { unmappedAttributeValues };
